define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/heading/AggregateController",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare, lang, AggregateController, locale, MessageDialog, xml) {

	return declare(AggregateController, {
		bHold: false,

		hasToConfirmAction: function() {
			return true;
		},

		confirmAction: function(/*Object*/params) {
			// summary: do not allow action if product structure is on frozen BOM rev
			this.m_writer.callMethod("MaterialSpec", "StyleValidateReplaceProductStructure")
				.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlNode);

			this.m_writer.execute({
				load: lang.hitch(this, this.preProcess),
				error: lang.hitch(this, this._onPublishError)
			});
		},

		publish: function() {
			// summary: confirm action if the user is changing product structure within drop down list.
			var urlOld = this.oldValue;
			var urlNew = this.newValue;

			if (!this._bPopup && xml.isValidURL(urlOld) && urlNew != urlOld) {
				AggregateController.prototype.confirmAction.call(this, {
					materialIcon: MessageDialog.ICON_WARNING,
					title: locale.resource("WARNING"),
					buttons: [MessageDialog.BUTTON_YES, MessageDialog.BUTTON_NO + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL],
					message: locale.resource("ProductStructureChangePrompt")
				});
			} else {
				this.inherited(arguments);
			}
		},

		onConfirm: function(/*String*/key) {
			if (key == "Y") {
				AggregateController.prototype.publish.call(this);
			} else {
				this.postProcess();
			}
		}
	});
});